import { render } from "./mvt-lazyload.vue?vue&type=template&id=b4185fa0"
import script from "./mvt-lazyload.js?vue&type=script&lang=js"
export * from "./mvt-lazyload.js?vue&type=script&lang=js"

import "./mvt-lazyload.vue?vue&type=style&index=0&id=b4185fa0&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__